// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__34S_z","content":"styles_content__I5Old","loader":"styles_loader__TLFUv","rotate":"styles_rotate__rgh0D"};